/**
 * What the terms of service tell search engines and link previews — ONE copy, read by today's page
 * (src/pages/Terms.tsx) and its rebuild in the new design (src/design/pavilion/pages/terms-of-service/), the way
 * src/config/aboutSeo.ts serves both about pages (PV5a, design record §7b lane A).
 *
 * THE SHAPE IS READ BY THE GUEST CHAT'S KNOWLEDGE SOURCE (scripts/generate-guest-knowledge-source.mjs lists this file
 * for "/terms-of-service"): its extractor takes a `title:` / `description:` field whose string sits on the same line,
 * so each stays one line.
 */

/** Where search files the terms of service, whichever address served them. */
export const TERMS_CANONICAL_URL = 'https://prest0.ai/terms-of-service';

/** The props both terms of service pages hand to <SeoHead>. */
export const TERMS_SEO = {
  title: 'Terms of Service | prest0',
  tabTitle: 'terms of service',
  description: "Review prest0's Terms of Service governing use of our enterprise legal AI platform for law firms and legal professionals.",
  keywords: 'terms of service, prest0 terms, enterprise legal AI terms, legal AI platform agreement',
  canonicalUrl: TERMS_CANONICAL_URL,
  schemaType: 'WebPage',
} as const;
